import { LinkTabItem } from "./LinkTabItem";
import { LinkTabsList } from "./LinkTabsList";

export const LinkTabs = {
    List: LinkTabsList,
    Item: LinkTabItem,
};
